import { EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'
import { type ExperimentType } from '../model/Experiment.types'

import { useRemovePackagesForExpaExperimentIsExpaPresentInUrl } from './components/useIsExpaPresentInUrl'

export const useRemoveVariantsExperimentShouldHideVariantsForExpa = (
  removePackSizesExperiment: ExperimentType,
): boolean => {
  const isExpaPresentInUrl =
    useRemovePackagesForExpaExperimentIsExpaPresentInUrl()

  return (
    removePackSizesExperiment.isEnabled &&
    removePackSizesExperiment.variant === EXPERIMENT_VARIATION.V1 &&
    isExpaPresentInUrl
  )
}
